import { MailMinus } from "lucide-react";
import React from "react";
import { FaFacebookF, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer card m-auto">
      <div className="footer-container card-body m-auto">
        <div className="footer-column">
          <h2 className="footer-logo" style={{ maxWidth: '80%' }}><img src="/images/final_Logo_Image.jpeg" /></h2>
        </div>

        <div className="footer-column">
          <h5 className="footer-heading">Product</h5>
          <ul className="footer-list">
            <li>Home</li>
            <li>Pricing</li>
          </ul>
        </div>

        <div className="footer-column">
          <h5 className="footer-heading">Support</h5>
          <ul className="footer-list">
            <li>Refund & Cancellation</li>
            <li>User guides</li>
            <li>Webinars</li>
          </ul>
        </div>

        <div className="footer-column">
          <h5 className="footer-heading">Company</h5>
          <ul className="footer-list">
            <li>About</li>
            <li>Contact us</li>
          </ul>
        </div>

        <div className="footer-subscribe">
          <h5 className="footer-subscribe-title">Subscribe to our newsletter</h5>
          <p className="footer-subscribe-subtext">
            For product announcements and exclusive insights
          </p>
          <div className="footer-input-container ">
            <div className="d-flex bg-slate-200">
              <span className="bg-slate-200 m-2"> 
                <MailMinus /></span> <input type="email" placeholder="Input your email" className="outline-none focus-none bg-slate-200 border-none" style={{border: 'none'}}/>
            </div>

            <button>Subscribe</button>
          </div>
        </div>
      </div>

      <div className="w-full py-4 bg-white">
        <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center lg:items-center">

          {/* Center Text on Large */}
          <div className="flex-1 text-sm text-gray-700 text-center">
            <span>© Zaidi Corporation 2025. All Rights Reserved</span>
            <span className="mx-2">| Privacy</span>
            <span>| Terms</span>
          </div>

          {/* Icons Right End */}
          <div className="flex justify-center lg:justify-end space-x-4 text-gray-700 text-lg mt-2 lg:mt-0 w-full lg:w-auto">
            <FaFacebookF className="hover:text-blue-600 cursor-pointer" />
            <FaYoutube className="hover:text-red-600 cursor-pointer" />
          </div>

        </div>
      </div>

    </footer>
  );
};

export default Footer;
